import React from 'react';

import LabelTag from './LabelTag';

const DisplaySelectLabel = ({ value }) => {
    return <LabelTag style={{ backgroundColor: value.color }} value={value} />;
};

export default DisplaySelectLabel;
